import { SelectionModel } from '@angular/cdk/collections';
import { createReducer, on } from '@ngrx/store';
import { TodoItemFlatNode } from 'src/app/catalogue/folders/folders.component';
import { setFolderSelectionList } from '../actions/catalogue.actions';

export const initialState: {
  folderSelectionList: SelectionModel<TodoItemFlatNode>;
} = { folderSelectionList: new SelectionModel() };

export const catalogueReducer = createReducer(
  initialState,
  on(setFolderSelectionList, (state, payload) => {
    state.folderSelectionList = payload;
    return state;
  })
);
